import { fromJS } from 'immutable';
import { ApiUrl5, UserToken } from '../../../helper/HelperAuth'
import { GetInteractiveSummary } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (body) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl5 + 'interactive-summary';
    const argument = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': Authorization,
        },
        body: JSON.stringify(body)
    };

    const response = await doFetch(url, argument);
    var data = fromJS({});
    var formVal = fromJS({});
    if (response.ok) {
        data = fromJS(await response.json());
        data = data.get("interactive-summary")
        formVal = data
        var queue = data.get('queue-tickets') == undefined ? "0" : data.get('queue-tickets')
        formVal = formVal.set('queue-tickets',queue)
        data = formVal
      
    }
    dispatch({ type: GetInteractiveSummary, data:fromJS(data)});
    return data
};